import { Record } from 'immutable';

import { ProjectElementsEntity } from '../components/project-delete-popup/project-elements.entity';
import { ProjectListEntity } from '../components/project-list/project-list.entity';
import { ProjectMemberEntity } from '../components/project-list/project-member.entity';

export const ProjectSliceKey = 'main';

export interface IProjectOriginalSliceState {
	loading: boolean;
	projects: ProjectListEntity;
	projectsViewMode: string;
	searchTerm: string;
	isLoadingMembers: boolean;
	isDeletingInProgress: boolean;
	hasOrphanProjects: boolean;
}

export const defaults: IProjectOriginalSliceState = {
	loading: false,
	projects: ProjectListEntity.build([]),
	projectsViewMode: '',
	searchTerm: '',
	isLoadingMembers: false,
	isDeletingInProgress: false,
	hasOrphanProjects: false,
};

export class ProjectSliceState extends Record<IProjectOriginalSliceState>(
	defaults
) {
	public static readonly key = ProjectSliceKey;

	public setLoading(isLoading: boolean): ProjectSliceState {
		return this.set('loading', isLoading);
	}

	public setProjects(projects: ProjectListEntity): ProjectSliceState {
		return this.set('projects', projects);
	}

	public setProjectsViewMode(val: string): ProjectSliceState {
		return this.set('projectsViewMode', val);
	}

	public setProjectsSearchTerm(val: string): ProjectSliceState {
		return this.set('searchTerm', val);
	}

	public setLoadingMembers(isLoading: boolean): ProjectSliceState {
		return this.set('isLoadingMembers', isLoading);
	}

	public updateProjectsWithMembers(
		projectId: number,
		members: Array<ProjectMemberEntity>
	): ProjectSliceState {
		return this.set(
			'projects',
			this.projects.setProjectMembers(projectId, members)
		);
	}

	public updateProjectsWithCriticalAndDcElements(
		projectId: number,
		elements: ProjectElementsEntity,
		isCritical: boolean
	): ProjectSliceState {
		return this.set(
			'projects',
			this.projects.setProjectCriticalAndElements(
				projectId,
				elements,
				isCritical
			)
		);
	}

	public updateProjectsWithDeletable(
		projectId: number,
		isDeletable: boolean
	): ProjectSliceState {
		return this.set(
			'projects',
			this.projects.setProjectDeletable(projectId, isDeletable)
		);
	}

	public resetProject(id: number): ProjectSliceState {
		return this.set('projects', this.projects.resetProject(id));
	}

	public setDeletingInProgress(
		isDeletingInProgress: boolean
	): ProjectSliceState {
		return this.set('isDeletingInProgress', isDeletingInProgress);
	}

	public setOrphanProjects(hasOrphanProjects: boolean): ProjectSliceState {
		return this.set('hasOrphanProjects', hasOrphanProjects);
	}
}
